import React, { useState } from "react";
import { SliderTypes } from "../../../types/ContentCard";
import { detectDeviceType } from "../../../utils/detectDeviceType";
import { SliderContainer } from "./SliderStyles";
import ReactSlider from "react-slider";
import { Persona } from "@soulmachines/smwebsdk";

const Slider: React.FC<{
  contentCardData: SliderTypes;
  tabletLandscape: boolean;
  persona: Persona;
  dispatch: Function;
  active: boolean;
}> = ({ contentCardData, tabletLandscape, persona, dispatch, active }) => {
  const [selected, setSelected] = useState(
    contentCardData.data.sliderOptions[0].sliderValue
  );

  return (
    <SliderContainer
      deviceType={detectDeviceType()}
      isLandscape={tabletLandscape}
      data-sm-content="slider"
    >
      <h1>{contentCardData.data.header}</h1>
      <div>
        <div className="labels">
          {contentCardData.data.sliderOptions.map((options, index) => {
            return <p key={index}>{options.sliderText}</p>;
          })}
        </div>
        <ReactSlider
          className="horizontal-slider"
          marks
          min={0}
          disabled={!active}
          max={contentCardData.data.sliderOptions.length - 1}
          thumbClassName="example-thumb"
          trackClassName="example-track"
          renderThumb={(props, state) => <div {...props} />}
          onAfterChange={(props) => {
            setSelected(contentCardData.data.sliderOptions[props].sliderValue);
          }}
        />
      </div>
      <button
        type="button"
        onClick={() => {
          persona.conversationSend(selected, {}, {});
          dispatch({
            type: "ADD_CONVERSATION_MESSAGE",
            payload: {
              source: "user",
              text: selected,
            },
          });
        }}
      >
        Submit
      </button>
    </SliderContainer>
  );
};

export default Slider;
